import { handleResult, post } from '@/util';
import { Iuser, Result } from '@/typings';

/**
 * 注册
 * @returns
 */
export function register(params: Iuser) {
	return new Promise<any>((resole, reject) => {
		post(
			'/auth/register',
			params,
			(result: Result<null>) => {
				handleResult(
					result,
					({ data }) => {
						resole({ msg: '注册成功！', data });
					},
					msg => {
						reject(msg);
					},
				);
			},
			msg => {
				reject({ msg });
			},
			true,
		);
	});
}
/**
 * 发送验证码
 * @returns
 */
export function sendVerificationCode(params: { type: string; identifier: string }) {
	return new Promise<any>((resole, reject) => {
		post(
			'/auth/send-verification-code',
			params,
			(result: Result<null>) => {
				handleResult(
					result,
					({ data }) => {
						resole(data);
					},
					msg => {
						reject(msg);
					},
				);
			},
			msg => {
				reject({ msg });
			},
			true,
		);
	});
}
